<template>
  <div class="t15 h-screen">
    <h1 class="heading--invisible">{{ $t("meta.aboutus.h1") }}</h1>
    <div class="form-section-static first-section ">
      <div class="crs_content ">
        <navbar>
          <template slot="collapse">
            <navbar-nav>
              <li
                v-bind:class="{
                  active: !$route.params.id || $route.params.id == 'my'
                }"
              >
                <router-link to="/aboutus/my" hreflang="en-MY"
                  >Pizza hut Malaysia</router-link
                >
              </li>
              <li v-bind:class="{ active: $route.params.id == 'ww' }">
                <router-link to="/aboutus/ww" hreflang="en-MY"
                  >Pizza hut Worldwide</router-link
                >
              </li>
            </navbar-nav>
          </template>
        </navbar>
      </div>
    </div>
    <div
      class="row  xs-fill-white py-20 lg:px-60"
      style="margin: auto; max-width: 990px"
    >
      <div
        class="selection-time text-center pb20"
        style="position: relative;overflow: hidden; margin: auto;max-width: 960px"
      >
        <div v-if="!$route.params.id || $route.params.id == 'my'">
          <h2 class="cl-red t22 pb-10">Pizza Hut Malaysia</h2>
          <div class="text-left t14">
            <p>
              Pizza Hut first opened in Malaysia in 1982, with its restaurant
              located in the modest Plaza Yow Chuan, Kuala Lumpur. Today, the
              Pizza Hut chain had grown into more than 428 restaurants under its
              sole franchisee, QSR Brands (M) Holdings Bhd. With extensive
              collaborations in top tier breeder and contract broiler farming,
              hatchery, poultry production and processing, Pizza Hut is without
              a doubt an immense host of ancillary businesses as well, including
              baking, commissary and sauce production.
            </p>
            <p>
              As the largest pizza chain in Malaysia, Pizza Hut has truly come a
              long way from its humble beginnings- even with more than 500 Pizza
              Hut restaurants throughout Malaysia and Singapore under its belt,
              Pizza Hut still managed to consistently deliver on its main
              goal-that is providing delicious, piping hot pizza and smiles of
              happiness to all customers throughout Malaysia.
            </p>
            <p>
              Staying true to its motto - “Easy” and “Better”, it is the brand’s
              mission to make it tremendously easy for consumers to order their
              favourite pizza that is quick to arrive and affordable, so more
              people can enjoy. The motto “Better” also highlights Pizza Hut’s
              passion to deliver quality products and fantastic experiences that
              exceed all expectations, time and time again.
            </p>
            <p>
              Without a doubt, Pizza Hut Malaysia will continue to expand and
              evolve through the development of casual dining (Pizza Hut
              Restaurant) and delivery stores models (Pizza Hut Delivery)
              catering to all generations that sought for delicious, quality
              meals at a great convenience.
            </p>
            <p>
              Pizza Hut Restaurant offers a cosy & friendly ambience coupled
              with great hospitality, which makes it the perfect place for one
              to relax and unwind while having a joyful time with family and
              friends.
            </p>
            <p>
              The Covid-19 pandemic situation has contributed positively in the
              enhancement of stringent food-safety and hygiene standards,
              introducing measures such as increased cleaning and sanitisation
              frequency, disinfecting of high touchpoint surfaces, provision of
              hand sanitisers, health checks and training of new procedures for
              all its team members so that customers can enjoy their favourite
              pizzas safely with ease.
            </p>
            <p>
              With that in mind, customers who opt to dine at home can also do
              so happily knowing that Pizza Hut Delivery guarantees to provide
              hot & fresh oven-baked pizzas within a promised delivery time to
              customers, every single time.
            </p>
            <p>
              Pizza Hut believes there’s real joy in sharing a great pizza; it
              creates precious moments with families and friends that’s
              unparalleled to any other. Throughout the years, this simple dish
              overcame its modest origins to achieve world-wide fame and
              appreciation, all the whole offering great meal deals and multiple
              delicious and savoury options for easy pick up or delivery.
            </p>
            <p>
              So, the next time you’re wondering, ‘Hmmm, I wonder, where I can
              find a tasty pizza shop near me? you’ll know that a piping hot,
              mouth-watering and oven fresh Supreme or Pepperoni Pizza is just
              around the corner!
            </p>
          </div>
        </div>
        <div v-else-if="$route.params.id == 'ww'">
          <h2 class="cl-red t22 pb-10">Pizza Hut Worldwide</h2>
          <div class="text-left t14">
            <p>
              In Wichita, brothers Frank and Dan Carney opened the first Pizza
              Hut restaurant on June 15, 1958. They had been approached by the
              owner of a small building who wanted a nice neighbourhood
              business, and had read the Post's article about pizza. The Carneys
              borrowed $600 from their mother, located John Bender, an airman
              from McConnell Air Force Base who had worked as a pizza cook,
              purchased some second-hand equipment and were ready for business.
              The first night, they gave away pizza to interest potential
              customers.
            </p>
            <p>
              Many people ask how Pizza Hut got its name. When the Carneys were
              setting up that first restaurant, the building has a sign with
              room for just nine characters. They wanted to use "pizza" in the
              name, which left room for a word with only three characters. A
              family member suggested the building looked like a hut....and
              Pizza Hut was born.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>



// WEBPACK FOOTER //
// src/pages/static/Aboutus.vue